import ServicePage from './ServicePage';

const Neurofeedback = () => <ServicePage serviceKey="neurofeedback" />;

export default Neurofeedback;
